//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordStudyChip from '@/components/innovation/WordStudyChip.vue'
export default {
  components: { WordStudyChip },
  data () { return { scene: {}, words: [], dialogues: [] } },
  created () {
    this.$ajax.get(this.$api.cpSceneDetail + '?id=' + this.$route.query.id).then(r => {
      this.scene = (r && r.scene) || {}
      this.words = (r && r.words) || []
      this.dialogues = (r && r.dialogues) || []
    })
  },
  methods: {
    shortMean (w) {
      const m = w.meaning || w.hint || w.wordMeaning || ''
      return String(m).slice(0, 24)
    },
    start () { this.$router.push({ path: '/cpPuzzle_display', query: { id: this.$route.query.id } }) }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/scene-start.vue